import { render, staticRenderFns } from "./table-month.vue?vue&type=template&id=4022e4cb&"
import script from "./table-month.vue?vue&type=script&lang=js&"
export * from "./table-month.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports